/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/overlays/presentation-overlay',['require','core/base-screen','core/overlay-screen'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var BaseScreen = require('core/base-screen');
  var OverlayScreen = require('core/overlay-screen');

  /*****************************************************************************************************************///}

  var PresentationOverlay = OverlayScreen.extend({

  /////////////
  // METHODS /{
  /////////////

    setInterface: function()
    {
      var ui = { 'help': false, 'caption': true, 'badge': false, 'home': false };
      this.radio.trigger('ui.update', ui);
    },

    onShow: function()
    {
      if (this.model.get('media'))
        this.playMedia(null, {showBtns: false});
      else
        this.finish();
    },

    onMediaEnded: function(e)
    {
      BaseScreen.prototype.onMediaEnded.apply(this, arguments);

      this.finish();
    }

  /*****************************************************************************************************************///}

  });

  return PresentationOverlay;

});

